import { Navigate, useLocation } from 'react-router-dom';
import { userCanAccessRoute } from './contexts/user-context';

export const PrivateRoute = ({ component, requiredRoles = [], ...rest }) => {
  const Component = component;
  const location = useLocation();

  if (userCanAccessRoute(requiredRoles)) {
    return <Component {...rest} />;
  } else {
    return <Navigate to="/signin" state={{ from: location }} />;
  }
};
